export enum HttpResponseStatus {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  PRECONDITION_FAILED = 412,
  PAYLOAD_TOO_LARGE = 413,
  INTERNAL_SERVER_ERROR = 500,
  SERVICE_UNAVAILABLE = 503,
}
